import React from 'react'

import Text from '../../../../components/pdf/Text'
import View from '../../../../components/pdf/View'
import Separator from '../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../components/pdf/Table'
import Grid, { Col } from '../../../../components/pdf/Grid'
import { useReplies } from '../_load/ServiceOrderLoader'
import { findReplyByQuestionId, getReplyValue } from '../_helpers/pdfHelpers'
import { formatDate } from '@btime/helpers'

const FormularioPageContent = () => {
  const replies = useReplies()

  const dataAbertura = getReplyValue(findReplyByQuestionId(replies, 281)) || ''
  const dataAberturaFormatada = formatDate('DD/MM/YYYY', dataAbertura)
  const localAbertura = getReplyValue(findReplyByQuestionId(replies, 282)) || ''
  const bancoAvisador = getReplyValue(findReplyByQuestionId(replies, 283)) || ''
  const moeda = getReplyValue(findReplyByQuestionId(replies, 284)) || ''
  const valor = getReplyValue(findReplyByQuestionId(replies, 285)) || ''
  const toleranciaValor = getReplyValue(findReplyByQuestionId(replies, 480)) || ''
  const percentualToleranciaMenos = getReplyValue(findReplyByQuestionId(replies, 481)) || ''
  const percentualToleranciaMais = getReplyValue(findReplyByQuestionId(replies, 482)) || ''
  const toleranciaQuantidade = getReplyValue(findReplyByQuestionId(replies, 483)) || ''
  const percentualToleranciaQuantidadeMenos = getReplyValue(findReplyByQuestionId(replies, 484)) || ''
  const percentualToleranciaQuantidadeMais = getReplyValue(findReplyByQuestionId(replies, 485)) || ''
  const bancoNegociador = getReplyValue(findReplyByQuestionId(replies, 286))
  const tomador = getReplyValue(findReplyByQuestionId(replies, 287)) || ''
  const agenciaContaDebito = getReplyValue(findReplyByQuestionId(replies, 288))
  const contaDebito = getReplyValue(findReplyByQuestionId(replies, 289)) || ''
  const autorizacaoCredito = getReplyValue(findReplyByQuestionId(replies, 290))
  const autorizacaoParcelasVencidas = getReplyValue(findReplyByQuestionId(replies, 291)) || ''
  const enderecoTomador = getReplyValue(findReplyByQuestionId(replies, 292))
  const nomeExportador = getReplyValue(findReplyByQuestionId(replies, 293)) || ''
  const enderecoBeneficiario = getReplyValue(findReplyByQuestionId(replies, 294)) || ''
  const comissaoAgente = getReplyValue(findReplyByQuestionId(replies, 295))?.name.split(' - ')[0]
  const domicilioAgente = comissaoAgente === 'Retida no país' ? getReplyValue(findReplyByQuestionId(replies, 477)) : ''
  const localEmbarque = getReplyValue(findReplyByQuestionId(replies, 296)) || ''
  const dataEmbarque = getReplyValue(findReplyByQuestionId(replies, 297))
  const dataEmbarqueFormatada = formatDate('DD/MM/YYYY', dataEmbarque)
  const embarquesParciais = getReplyValue(findReplyByQuestionId(replies, 298)) || ''
  const transbordos = getReplyValue(findReplyByQuestionId(replies, 299)) || ''
  const prazoPagamento = getReplyValue(findReplyByQuestionId(replies, 300))?.name || ''
  const diasPagamento = getReplyValue(findReplyByQuestionId(replies, 301)) || ''
  const tipoDiasPagamento = getReplyValue(findReplyByQuestionId(replies, 302))?.name || ''
  const prazoPagamentoCompleto =
    prazoPagamento === 'A prazo em' ? `${prazoPagamento} ${diasPagamento} dias do ${tipoDiasPagamento}` : prazoPagamento
  const localDesembarque = getReplyValue(findReplyByQuestionId(replies, 303)) || ''
  const paisOrigem = getReplyValue(findReplyByQuestionId(replies, 304)) || ''
  const ncm = getReplyValue(findReplyByQuestionId(replies, 305))
  const descricaoMercadoria = getReplyValue(findReplyByQuestionId(replies, 306)) || ''
  const mercadoriaConforme = getReplyValue(findReplyByQuestionId(replies, 307))?.name
  const numeroMercadoria = getReplyValue(findReplyByQuestionId(replies, 308)) || ''
  const saqueEmitido = getReplyValue(findReplyByQuestionId(replies, 309)) || ''
  const documentosEmbarque = getReplyValue(findReplyByQuestionId(replies, 310))?.name
  const numeroOriginais = getReplyValue(findReplyByQuestionId(replies, 311)) || ''
  const numeroCopias = getReplyValue(findReplyByQuestionId(replies, 312)) || ''
  const condicoesDeEmissaoEmbarque = getReplyValue(findReplyByQuestionId(replies, 313))?.name
  const condicoes = getReplyValue(findReplyByQuestionId(replies, 314)) || ''
  const faturaComercial = getReplyValue(findReplyByQuestionId(replies, 315))?.name || ''
  const frete = getReplyValue(findReplyByQuestionId(replies, 316))?.name || ''
  const outrosDocumentos = getReplyValue(findReplyByQuestionId(replies, 317)) || ''
  const diasParaApresentacao = getReplyValue(findReplyByQuestionId(replies, 318)) || ''
  const condicoesEspeciais = getReplyValue(findReplyByQuestionId(replies, 319)) || ''
  const despesasECommissoesInternas = getReplyValue(findReplyByQuestionId(replies, 320))?.name || ''
  const despesasECommissoesExternas = getReplyValue(findReplyByQuestionId(replies, 321))?.name || ''
  const confirmacaoDeCredito = getReplyValue(findReplyByQuestionId(replies, 322))?.name || ''
  const bancoConfirmador = getReplyValue(findReplyByQuestionId(replies, 323)) || ''
  const premioSeguro = getReplyValue(findReplyByQuestionId(replies, 324))?.name || ''
  const seguradora = getReplyValue(findReplyByQuestionId(replies, 325)) || ''

  return (
    <>
      <View pageBreakAfter>
        <Text semibold size="h6">
          Ao <br />
          BANCO DO BRASIL S. A.
        </Text>
        <Separator weight={5} />
        <Text>Sr. Gerente,</Text>
        <Text>
          ABERTURA DE CRÉDITO DOCUMENTÁRIO PARA IMPORTAÇÃO DE MERCADORIAS - Solicitamos-lhe promover a abertura no
          exterior de um crédito documentário irrevogável para importação de mercadorias, de conformidade com as Regras
          e Usos Uniformes Relativos aos Créditos Documentários, revisão de 2007, publicação nº 600 da Câmara
          Internacional de Comércio, bem como com as Regras Uniformes para Reembolsos Bancários, amparados em créditos
          documentários, de 2008, publicação nº 725 da Câmara Internacional de Comércio, que declaramos conhecer, e de
          acordo, igualmente, com as condições constantes do presente pedido.
        </Text>
        <Separator weight={5} />
        <Table width="100%" fixedLayout useFontBaseColor style={{ border: 'none' }}>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Local e data</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    {localAbertura} - {dataAberturaFormatada}&nbsp;
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Banco avisador</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{bancoAvisador}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="4">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Moeda</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{moeda}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="8">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Valor</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{valor}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="5">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Tolerância valor</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{toleranciaValor ? 'Sim' : 'Não'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="7">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Percentual de Tolerância</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    {percentualToleranciaMenos} - {percentualToleranciaMais}&nbsp;
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="5">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Tolerância quantidade</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{toleranciaQuantidade ? 'Sim' : 'Não'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="7">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Percentual de Tolerância</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    {percentualToleranciaQuantidadeMenos} - {percentualToleranciaQuantidadeMais}&nbsp;
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Banco negociador</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{bancoNegociador}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Tomador</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{tomador}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Agência da conta para débito </Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{agenciaContaDebito}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Conta para débito</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{contaDebito}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Autorização da utilização do limite de crédito (Cheque Especial)</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{autorizacaoCredito ? 'Sim' : 'Não'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Autorização para realização de lançamentos parciais e de parcelas vencidas</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{autorizacaoParcelasVencidas ? 'Sim' : 'Não'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Endereço do Tomador</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    &nbsp;{enderecoTomador?.address} - {enderecoTomador?.complement}
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="4">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Bairro do Tomador </Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{enderecoTomador?.neighborhood}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="4">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Cidade do Tomador </Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{enderecoTomador?.city}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="4">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>UF do Tomador</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{enderecoTomador?.state}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Beneficiário</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{nomeExportador}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Endereço do Beneficiário</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    &nbsp;{enderecoBeneficiario?.address} - {enderecoBeneficiario?.complement}
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="5">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Cidade do Beneficiário</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{enderecoBeneficiario?.city}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="7">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>País do Beneficiário</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{enderecoBeneficiario?.country}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Comissão do agente a ser deduzida do crédito</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{`${comissaoAgente} ${domicilioAgente ? `- ${domicilioAgente}` : ''}`}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Local de embarque</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{localEmbarque}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Prazo ou data prevista para embarque</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{dataEmbarqueFormatada}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
        </Table>
      </View>
      <View pageBreakAfter>
        <Table fixedLayout width="100%" useFontBaseColor style={{ border: 'none' }}>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Local e data de vencimento do crédito</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{embarquesParciais ? 'Permitidos' : 'Não permitidos'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="4">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Embarques parciais</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{embarquesParciais ? 'Permitidos' : 'Não permitidos'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="8">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Transbordos</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{transbordos ? 'Permitidos' : 'Não permitidos'}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Por pagamento</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{prazoPagamentoCompleto}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="5">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Local de descarga </Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{localDesembarque}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="7">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>País de origem da mercadoria</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{paisOrigem}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>NCM, Destaque de NCM e Mercadoria</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{ncm}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Descrição da Mercadoria:</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{descricaoMercadoria}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Mercadoria conforme</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{`${mercadoriaConforme} - nº: ${numeroMercadoria}`}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Saque(s) emitidos pelo beneficiário com vencimento em</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{saqueEmitido}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
        </Table>
        <Text semibold size="h5">
          Documentos a serem exigidos do beneficiário
        </Text>
        <Table fixedLayout width="100%" useFontBaseColor pageBreakInside style={{ border: 'none' }}>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Documentos de embarque</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{documentosEmbarque}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="7">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Número de originais </Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{numeroOriginais}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="5">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Número de cópias</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{numeroCopias}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Condições de emissão dos documentos de embarque</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    &nbsp;{condicoesDeEmissaoEmbarque} {condicoes}
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Fatura Comercial</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{faturaComercial}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Frete</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{frete}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Outros documentos</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{outrosDocumentos}&nbsp;</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>
                    Os documentos deverão ser apresentados até {diasParaApresentacao} dias da data de emissão dos
                    documentos de embarque, mas dentro do prazo de validade do crédito.
                  </Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Condições especiais</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{condicoesEspeciais}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Despesas e comissões internas (se houver) devem correr</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{despesasECommissoesInternas}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Despesas e comissões externas (se houver) devem correr</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{despesasECommissoesExternas}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Confirmação do crédito</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{confirmacaoDeCredito}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="12">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Banco Confirmador (se houver)</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{bancoConfirmador}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
          <TableRow useFontBaseColor style={{ borderTop: 'none', borderRight: 'none' }}>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Prêmio de seguro: pagamento a cargo</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{premioSeguro}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
            <TableCol useFontBaseColor style={{ borderLeft: '4px solid #ffcc00' }} colspan="6">
              <Grid gutter={1.5} direction="column" align="start">
                <Col gutter={1.5}>
                  <Text>Seguradora</Text>
                </Col>
                <Col gutter={1.5}>
                  <Text>{seguradora}&nbsp;</Text>
                </Col>
              </Grid>
            </TableCol>
          </TableRow>
        </Table>
      </View>
      <View pageBreakAfter>
        <Text>
          1. Declaramo-nos cientes de que esse Banco e seus correspondentes não assumirão qualquer responsabilidade
          quanto:
        </Text>
        <Text>a) à correção, validade ou legitimidade de qualquer documento mencionado na página 01 deste;</Text>
        <Text>
          b) à espécie, quantidade, qualidade ou entrega de mercadorias que tais documentos digam representar;
        </Text>
        <Text>
          c) às consequências de qualquer engano, atraso ou omissão na transmissão da correspondência, inclusive
          telegráfica;
        </Text>
        <Text>d) ao extravio de documentos.</Text>
        <Text>
          2. Declaramo-nos, também, cientes de que pode esse Banco exigir de nós depósito prévio em moeda nacional, em
          conta vinculada ao crédito, em montante a ser estabelecido pelo Banco, suficiente para a liquidação do
          crédito, e pelo presente nos obrigamos a não utilizar, para qualquer fim, o depósito que venha a ser
          constituído com esse propósito, enquanto não for integralmente liquidado o crédito objeto deste pedido.
        </Text>
        <Text>
          3. Uma vez liquidado o crédito a que se refere este pedido e resgatados todos os nossos compromissos dele
          decorrentes, a garantia de remanescente, se houver, inclusive eventual saldo na conta vinculada ao crédito
          poderá ser retida por esse Banco para aplicação no pagamento de outras dívidas por que respondamos, junto a
          qualquer uma de suas agências.
        </Text>
        <Text>
          4. Sempre que não exigida a integralização prévia do depósito em moeda nacional em conta vinculada ao crédito,
          obrigamo-nos a contratar seguro no País, em favor do Banco, da mercadoria a ser importada ou, quando admitida
          a realização do seguro no exterior, autorizamos a inclusão no crédito, de cláusula exigindo a emissão da
          respectiva apólice em favor do Banco – válido o seguro, em ambas as hipóteses, por 60 dias após a descarga da
          mercadoria no local de destino, cobrindo todos os riscos de perdas ou danos físicos provenientes de qualquer
          causa (nos termos da INSTITUTE CARGO CLAUSES – All Risks), sem restrição de percentagem (exceto nos casos de
          franquia dedutível obrigatória) e estendido para incluir greves, comoções civis e guerra (esta exceto quando a
          mercadoria for transportada por via terrestre, fluvial ou lacustre), na forma do INSTITUTE STRIKES RIOTS AND
          CIVIL COMMOTIONS CLAUSES, com cláusula de transbordo, ficando ainda estabelecido que:
        </Text>
        <Text>
          a) se as mercadorias, por qualquer circunstância, não forem por nós recebidas, obrigamo-nos a fazer o
          pagamento de que trata o item 8, que poderá ser exigido pelo Banco, a seu critério, antes e independentemente
          do recebimento do valor do seguro;
        </Text>
        <Text>
          b) se não ocorrer a retirada dos documentos de importação até o vencimento do seguro da mercadoria,
          autorizamos expressamente o Banco a promover a renovação do seguro, em companhia de sua livre escolha,
          cobrindo todos os riscos a que esteja sujeita, sendo a respectiva apólice emitida em favor do Banco;
        </Text>
        <Text>
          c) se assim indicado na página 01, fica o Banco expressamente autorizado a pagar, em nosso nome e por nossa
          conta, o valor do prêmio do seguro contratado junto à companhia seguradora indicada na página 01. Esse valor
          será por nós reembolsado ao Banco, até a liquidação do contrato de câmbio, acrescido de juros correspondente à
          taxa estabelecida pelo Banco para a operação, contados da data do pagamento, pelo Banco, do valor do prêmio do
          seguro, até a data do seu reembolso por nós;
        </Text>
        <Text>
          d) se o pagamento do prêmio do seguro ficar a nosso cargo, obrigamo-nos a comprová-lo perante o Banco,
          imediatamente após efetivado. Na falta de comprovação do pagamento do prêmio em tempo hábil, fica o Banco
          autorizado a levar a débito de nossa conta o valor total financiado desta operação.
        </Text>
        <Text>
          5. Declaramo-nos cientes de que o Banco se exime de toda e qualquer responsabilidade pelos prejuízos
          porventura decorrentes de sinistro não coberto totalmente pelo seguro da mercadoria.
        </Text>
        <Text>
          6. Nos casos de mercadoria sujeita a licenciamento não automático anteriormente ao desembaraço aduaneiro,
          comprometemo-nos a obter a Licença de Importação ( L I ) junto ao órgão competente.
        </Text>
        <Text>
          7. Correrão por nossa conta todas as despesas do Banco e de seus correspondentes no exterior, inclusive
          aquelas que, embora a cargo do beneficiário, não venham a ser por ele satisfeitas. Tais encargos são devidos
          mesmo na hipótese de o crédito não vir a ser utilizado, parcial ou totalmente, no exterior e fica o Banco,
          desde já, autorizado a efetuar em nossa conta os débitos necessários.
        </Text>
        <Text>8. Comprometemo-nos, ainda:</Text>
        <Text>
          a) a celebrar com o Banco operação de câmbio da importância necessária à liquidação do crédito objeto do
          presente pedido de abertura, convertidos em moeda nacional à taxa de câmbio de venda praticada pelo Banco, nas
          seguintes oportunidades:
        </Text>
        <Text>
          I) crédito documentário à vista, sem financiamento - no ato do recebimento do aviso de negociação do crédito
          no exterior por esse Banco, independente do recebimento dos documentos;
        </Text>
        <Text>
          II) crédito documentário à vista, com financiamento de banqueiro e a prazo (financiamento do exportador) -
          dois dias úteis antes do vencimento de cada obrigação no exterior.
        </Text>
        <Text>
          b) a pagar ao Banco, até a data máxima admitida na legislação cambial para liquidação da operação de venda de
          câmbio vinculada ao crédito objeto do presente pedido de abertura, o contravalor em moeda nacional à taxa de
          câmbio de venda praticada pelo Banco, bem como o importe referente às demais despesas, comissões e encargos
          incidentes sobre a operação, haja ou não a mercadoria chegado ao local de destino.
        </Text>
        <Text>
          9. Conferimos ao Banco mandato irrevogável para celebrar, caso não compareçamos para fazê-lo na época própria,
          a operação de venda de câmbio referida no item 8, com poderes bastantes para assinar o contrato de câmbio pelo
          punho de seus funcionários e em nosso nome, assim como os demais documentos eventualmente necessários à cabal
          execução deste mandato.
        </Text>
        <Text>
          10. Ocorrendo a hipótese de o Banco, por força da legislação cambial e das publicações internacionais
          vinculadas à operação, vir a liquidar a operação sem a entrega dos recursos por nós compromissada, ficamos
          cientes de que, por ter havido inadimplemento contratual, ao Banco é assegurado o direito de exigir, a
          qualquer tempo, inclusive pela via judicial, o retorno de seus capitais, acrescido dos acessórios e demais
          despesas incidentes sobre a operação, a partir da data da liquidação da operação de câmbio, sobre o
          contravalor em moeda nacional da operação, sobre os acessórios e sobre as demais despesas, serão exigidos, nos
          termos da resolução 4.882, de 23 de dezembro de 2020, do conselho monetário nacional:
        </Text>
        <Text>
          a) juros remuneratórios correspondentes a 150% da taxa média dos certificados de depósitos interbancários -
          CDI, calculados com base na taxa equivalente diária (ano de 252 dias úteis);
        </Text>
        <Text>b) juros moratórios de 1% (um por cento) ao mês, ou fração, incidentes sobre o valor inadimplido;</Text>
        <Text>
          c) multa de 2% (dois por cento), calculada e exigida nos pagamentos parciais, sobre os valores amortizados, e
          na liquidação final, sobre o saldo devedor da dívida.
        </Text>
        <Text>
          PARÁGRAFO PRIMEIRO - para fins do disposto neste contrato, entende-se por dias uteis, todos os dias, exceto
          sábados, domingos e feriados bancários nacionais e, por CDI, a taxa média anual dos certificados de depósitos
          interbancários, divulgada pela central de liquidação financeira de títulos (Cetip).
        </Text>
        <Text>
          PARÁGRAFO SEGUNDO - os juros remuneratórios e os juros moratórios previstos nas alíneas "a" e "b" retro serão
          calculados, por dia de atraso, e exigidos nos pagamentos parciais e na liquidação da dívida, juntamente com as
          amortizações de principal, proporcionalmente aos seus valores nominais.
        </Text>
        <Text>
          PARÁGRAFO TERCEIRO - sem prejuízo dos encargos anteriormente previstos, o devedor responderá por prejuízos a
          que sua mora der causa, nos termos do artigo 395 do código civil, inclusive despesas de cobrança e honorários
          advocatícios quando devidos.
        </Text>
        <Text>
          11. Declaramo-nos cientes de que o Banco exercerá sobre as mercadorias importadas, bem como sobre os
          documentos que as representam e que lhe serão remetidos pelos seus correspondentes no exterior, o direito de
          retenção que lhe é assegurado pelos artigos 664 e 681 do Código Civil Brasileiro e mais leis em vigor, até ser
          reembolsado integralmente do principal, juros, comissões e despesas de crédito, ficando também o Banco, desde
          já, investido, por nós de poderes plenos e especiais, de forma irrevogável, para, se lhe convier, promover o
          desembaraço alfandegário das mercadorias, podendo recorrer ao órgão governamental competente no sentido de
          figurar como consignatário financiador da importação e, vencido o prazo a que se refere o item 8,
          independentemente de consulta, aviso ou interpelação judicial ou extrajudicial, vendê-las pública ou
          particularmente, pelo preço de mercado ou pelo melhor preço que for encontrado ou delas dispor de qualquer
          forma que julgar conveniente, a fim de se pagar dos desembolsos feitos, inclusive das despesas com o
          desembaraço e venda da mercadoria, prestando contas devidas e nos reclamando, por ação própria, eventual
          diferença ainda devida ao Banco.
        </Text>
        <Text>
          12. Ocorrendo saldo no crédito vincendo, e desde que concordemos, nós e o beneficiário, com a sua não
          utilização, ou na hipótese de o crédito tornar-se vencido, sem utilização pelo beneficiário, fica o Banco,
          desde já autorizado por nós a promover o cancelamento devido, bem como a levar a nossa conta, se for o caso, o
          valor em moeda nacional do saldo remanescente do depósito que tenha sido constituído conforme o item 2 retro.
          Para tanto, fica o Banco investido de plenos poderes para assinar, pelo punho de funcionários de seu quadro e
          em nosso nome, os novos instrumentos - inclusive contrato de câmbio - necessários a esses cancelamentos.
        </Text>
        <Text>
          13. Ocorrendo alterações nas condições do crédito a que se refere este pedido, assumimos o compromisso
          irrevogável e irretratável de honrar os saques e/ou documentos apresentados de acordo com as condições
          originais do crédito:
        </Text>
        <Text>a) antes da chegada do aviso da alteração às mãos do banqueiro no exterior; ou</Text>
        <Text>b) no caso de a emenda não ser aceita pelas demais partes interessadas.</Text>
        <Text>
          14. Tratando-se de crédito transferível, responsabilizamo-nos por todos os ônus ou prejuízos decorrentes da
          não regularização da LI, se mercadoria sujeita, no tratamento administrativo no DECEX, tempestivamente, na
          hipótese de o crédito vir a ser utilizado mediante apresentação de faturas de um segundo beneficiário,
          caracterizando assim a alteração de exportador.
        </Text>
        <Text>
          15. AUTORIZAÇÃO PARA DÉBITO EM CONTA POR PRAZO INDETERMINADO - Autorizamos o BANCO DO BRASIL S.A. a utilizar o
          saldo da conta de depósito acima indicada, por prazo indeterminado, para amortização ou liquidação da dívida
          resultante deste instrumento.
        </Text>
        <Text>
          PARÁGRAFO PRIMEIRO - Declaramo-nos cientes de que poderemos indicar outra conta de depósito mantida junto ao
          BANCO DO BRASIL S.A. para a realização de débitos decorrentes deste instrumento por meio de canais de
          atendimento disponibilizados pelo BANCO DO BRASIL S.A.
        </Text>
      </View>
    </>
  )
}

export default FormularioPageContent
